/**
 * The id for plot bands that represent UK recessions.
 */
export const UK_RECESSION_ID = 'recession-UK';

/**
 * The id for plot bands that represent US recessions.
 */
export const US_RECESSION_ID = 'recession-US';

/**
 * The date format for strings in the `categories` array.
 */
export const CATEGORY_FORMAT = 'MM/dd/yyyy';

/**
 * The maximum number of data points allowed in a linear series.
 */
export const LINEAR_SERIES_MAX_LENGTH = 44;

/**
 * A utility that takes in an object that has verbose time information about a recession and
 * transforms it into a more succinct number value.
 *
 * @param {{
 *   from: { month: number, year: number },
 *   to: { month: number, year: number }
 * }} recession An object containing verbose time information about a recession
 * @returns {RecessionData}
 */
const convertRecessionToDate = (recession) => ({
  from: new Date(recession.from.year, recession.from.month).getTime(),
  to: new Date(recession.to.year, recession.to.month).getTime(),
});

/**
 * An array containing objects representing the start and end of recessions in the US
 *
 * **Data from http://www.nber.org/cycles.html**
 */
export const US_RECESSIONS = [
  { from: { month: 5, year: 1857 }, to: { month: 11, year: 1858 } },
  { from: { month: 9, year: 1860 }, to: { month: 5, year: 1861 } },
  { from: { month: 3, year: 1865 }, to: { month: 11, year: 1867 } },
  { from: { month: 5, year: 1869 }, to: { month: 11, year: 1870 } },
  { from: { month: 9, year: 1873 }, to: { month: 2, year: 1879 } },
  { from: { month: 2, year: 1882 }, to: { month: 4, year: 1885 } },
  { from: { month: 2, year: 1887 }, to: { month: 3, year: 1888 } },
  { from: { month: 6, year: 1890 }, to: { month: 4, year: 1891 } },
  { from: { month: 0, year: 1893 }, to: { month: 5, year: 1894 } },
  { from: { month: 11, year: 1895 }, to: { month: 5, year: 1897 } },
  { from: { month: 5, year: 1899 }, to: { month: 11, year: 1900 } },
  { from: { month: 8, year: 1902 }, to: { month: 7, year: 1904 } },
  { from: { month: 4, year: 1907 }, to: { month: 5, year: 1908 } },
  { from: { month: 0, year: 1910 }, to: { month: 0, year: 1912 } },
  { from: { month: 0, year: 1913 }, to: { month: 11, year: 1914 } },
  { from: { month: 7, year: 1918 }, to: { month: 2, year: 1919 } },
  { from: { month: 0, year: 1920 }, to: { month: 6, year: 1921 } },
  { from: { month: 4, year: 1923 }, to: { month: 6, year: 1924 } },
  { from: { month: 9, year: 1926 }, to: { month: 10, year: 1927 } },
  { from: { month: 7, year: 1929 }, to: { month: 2, year: 1933 } },
  { from: { month: 4, year: 1937 }, to: { month: 5, year: 1938 } },
  { from: { month: 1, year: 1945 }, to: { month: 9, year: 1945 } },
  { from: { month: 10, year: 1948 }, to: { month: 9, year: 1949 } },
  { from: { month: 6, year: 1953 }, to: { month: 4, year: 1954 } },
  { from: { month: 7, year: 1957 }, to: { month: 3, year: 1958 } },
  { from: { month: 3, year: 1960 }, to: { month: 1, year: 1961 } },
  { from: { month: 11, year: 1969 }, to: { month: 10, year: 1970 } },
  { from: { month: 10, year: 1973 }, to: { month: 2, year: 1975 } },
  { from: { month: 0, year: 1980 }, to: { month: 6, year: 1980 } },
  { from: { month: 6, year: 1981 }, to: { month: 10, year: 1982 } },
  { from: { month: 6, year: 1990 }, to: { month: 2, year: 1991 } },
  { from: { month: 2, year: 2001 }, to: { month: 10, year: 2001 } },
  { from: { month: 11, year: 2007 }, to: { month: 5, year: 2009 } },
  { from: { month: 1, year: 2020 }, to: { month: 3, year: 2020 } },
].map(convertRecessionToDate);

/**
 * An array containing objects representing the start and end of recessions in the UK
 */
export const UK_RECESSIONS = [
  { from: { month: 4, year: 1956 }, to: { month: 9, year: 1956 } },
  { from: { month: 7, year: 1961 }, to: { month: 12, year: 1961 } },
  { from: { month: 7, year: 1973 }, to: { month: 3, year: 1974 } },
  { from: { month: 4, year: 1975 }, to: { month: 9, year: 1975 } },
  { from: { month: 1, year: 1980 }, to: { month: 3, year: 1981 } },
  { from: { month: 7, year: 1990 }, to: { month: 9, year: 1991 } },
  { from: { month: 4, year: 2008 }, to: { month: 6, year: 2009 } },
].map(convertRecessionToDate);
